Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Content1058237592",
  {"root":"Content1058237592--root"},
  ".Content1058237592--root{padding:24px 30px 30px}.Content1058237592--root[data-content1058237592-size=medium]{padding:30px}.Content1058237592--root[data-content1058237592-size=large]{padding:36px}.Content1058237592--root[data-content1058237592-emptystatecontent]{padding:42px}",
  1,
  "Content1058237592"
);
__webpack_require__.stylable.$.register(exports.default)
